import { render, staticRenderFns } from "./VueRecapchaUserRegister.vue?vue&type=template&id=64e8d3e3&"
import script from "./VueRecapchaUserRegister.vue?vue&type=script&lang=js&"
export * from "./VueRecapchaUserRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports